export default __webpack_public_path__ + "static/media/stairway.6c32e3cf.webp";